document.addEventListener('alpine:init', () => {
  Alpine.data('xFiltersAndSortby', (sectionId, defaultHideFilter) => ({
    t: '',
    show: false,
    showFilterAside: true,
    filterAsideOpened: false,
    hasActiveFilters: false,
    loading: false,
    isDesktop: false,
    listLayout: false,
    cachedResults: [],
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    init() {
      if (localStorage.getItem("list-layout") == 'list') {
        this.listLayout = true;
      }
      const isDefaultHide = defaultHideFilter !== undefined
        ? defaultHideFilter
        : !!(this.$el && this.$el.querySelector && this.$el.querySelector('.filter-aside\\:md\\:block'));
      if (isDefaultHide) {
        this.showFilterAside = false;
      }
      this._initLayout();
      this._setListeners();
      this._updateFilterAsideClass();
      this.$watch('showFilterAside', () => {
        this._updateFilterAsideClass();
      });
    },
    _updateFilterAsideClass() {
      const isDefaultHide = defaultHideFilter !== undefined
        ? defaultHideFilter
        : !!(this.$el && this.$el.querySelector && this.$el.querySelector('.filter-aside\\:md\\:block'));
      if (isDefaultHide) {
        if (this.showFilterAside) {
          this.$el.classList.add('filter-aside');
        } else {
          this.$el.classList.remove('filter-aside');
        }
      }
    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0];
      let formDrawer = document.getElementsByClassName('form-drawer')[0];
      if (window.innerWidth > 767) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      }
      window.addEventListener('popstate', onHistoryChange);

      installMediaQueryWatcher('(min-width: 768px)', this._initLayout);
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem("list-layout", theBoolean ? "list" : "grid" );
      window.dispatchEvent(new Event('resize'));
    },
    removeFilter(url) {
      this._reloadFilter(url);
    },
    renderPagination() {
      var formData = {
        'attributes': {
          'collection-pagination': this.$el.value             
        }
      }; 
      fetch(Shopify.routes.root+'cart/update', {
        method:'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData)
      }).then(() => {
        this.cachedResults = [];
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
      }); 
    },
    onSubmit(wait = 500) {
      clearTimeout(this.t);

      const func = () => {
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
        if(this.isDesktop) document.getElementById('FormSelectFilter')?.blur();
      }
      
      this.t = setTimeout(() => {
        func();
      }, wait);
    },
    rangePrice(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      priceInput = el.querySelectorAll(".price-input"),
      pricePreview = el.querySelectorAll(".price-preview"),
      range = el.querySelector(".slider .progress");
      let priceGap = 1;

      rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
          e.preventDefault();
          let minVal = Number(rangeInput[0].value).toFixed(2),
            maxVal = Number(rangeInput[1].value).toFixed(2);;
          
          if (maxVal - minVal < priceGap) {
            if (e.target.className === "range-min") {
              rangeInput[0].value = maxVal - priceGap;
              priceInput[0].value = maxVal - priceGap;
            } else {
              rangeInput[1].value = minVal + priceGap;
              priceInput[1].value = maxVal + priceGap;
            }
          } else {
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
            range.style.setProperty('--right_range', 100 - (maxVal / rangeInput[1].max) * 100 + '%');
          }
          pricePreview[0].textContent = minVal;
          pricePreview[1].textContent = maxVal;
        });
      });
    },
    initRange(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      range = el.querySelector(".slider .progress");
      
      let minVal = Number(rangeInput[0].value).toFixed(2),
      maxVal = Number(rangeInput[1].value).toFixed(2);;
      range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
      range.style.setProperty('--right_range',100 - (maxVal / rangeInput[1].max) * 100 + '%');
    },
    _reloadFilter(url) {
      let searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      const currentParams = new URLSearchParams(window.location.search);
      const nextParams = new URLSearchParams(searchParams);
      const isShopSearchTab = currentParams.get('search_tab') === 'shop' || currentParams.get('type') === 'product';

      if (isShopSearchTab && window.location.pathname.includes('/search')) {
        nextParams.set('type', 'product');
        nextParams.set('search_tab', 'shop');
        if (!nextParams.has('options[prefix]')) nextParams.set('options[prefix]', 'last');
        searchParams = nextParams.toString();
      }

      this._renderPage(searchParams);
    },
    _createSearchParams(form) {
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData);
      const currentParams = new URLSearchParams(window.location.search);
      const isShopSearchTab = currentParams.get('search_tab') === 'shop' || currentParams.get('type') === 'product';

      if (isShopSearchTab && window.location.pathname.includes('/search')) {
        searchParams.set('type', 'product');
        searchParams.set('search_tab', 'shop');
        if (!searchParams.has('options[prefix]')) searchParams.set('options[prefix]', 'last');
      }

      return searchParams.toString();
    },
    _updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    },
    _updateActiveFilterState(searchParams = '') {
      const params = new URLSearchParams(searchParams);

      this.hasActiveFilters = Array.from(params.keys()).some((key) => {
        return key.startsWith('filter.');
      });
    },
    _renderPage(searchParams, updateURLHash = true) {
      this.searchParamsPrev = searchParams;
      this._updateActiveFilterState(searchParams);
      this.loading = true;
      
      if (this.cachedResults[searchParams]) {
        this._renderResults(this.cachedResults[searchParams]);
        return;
      }

      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          this.cachedResults[searchParams] = html;
          this._renderResults(html);
        });

      if (updateURLHash) this._updateURLHash(searchParams);
    },
    _renderResults(html) {
      this._renderFilters(html);
      this._renderProductGridContainer(html);
      this._renderProductCount(html);
      this.loading = false;
    },
    _renderFilters(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      let blockFiltesDrawer = '.form-drawer';
      let blockFiltesAside = '.form-aside';
      const selectBlockFiltesDrawer = document.querySelector(blockFiltesDrawer);
      const selectBlockFiltesAside = document.querySelector(blockFiltesAside);
      let activeTag = document.getElementById("active-filter-tag")

      if (activeTag) {
        const parsedActiveTag = parsedHTML.getElementById("active-filter-tag");
        if (parsedActiveTag) activeTag.innerHTML = parsedActiveTag.innerHTML;
      }
      if (selectBlockFiltesDrawer) {
        if (this.$el.id) {  
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        const parsedFiltersDrawer = parsedHTML.querySelector(blockFiltesDrawer);
        if (parsedFiltersDrawer) selectBlockFiltesDrawer.innerHTML = parsedFiltersDrawer.innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      if (selectBlockFiltesAside) {
        if (this.$el.id) {
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        const parsedFiltersAside = parsedHTML.querySelector(blockFiltesAside);
        if (parsedFiltersAside) selectBlockFiltesAside.innerHTML = parsedFiltersAside.innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      this._renderAdvancedFilters(parsedHTML);
    },
    _renderAdvancedFilters(html) {
      const destination = document.querySelectorAll(".filter-advanced");
      const source = html.querySelectorAll('.filter-advanced');

      if (source.length > 0 && destination.length > 0) {
        destination.forEach((destination, index) => {
          destination.innerHTML = source[index].innerHTML;
        })
      }
    },
    _renderProductGridContainer(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const source = parsedHTML.getElementById('ProductGridContainer');
      const destination = document.getElementById('ProductGridContainer');
      if (source && destination) destination.innerHTML = source.innerHTML;
    },
  //  _renderProductCount(html) {
  //     const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  //     const productCountEl = parsedHTML.getElementById('ProductCount');

  //     if (!productCountEl) return;

  //     const count = productCountEl.innerHTML;

  //     document.querySelectorAll('#ProductCount, #ProductCount_header, #ProductCountDrawer, #facets-ProductCount').forEach((element) => {
  //       element.innerHTML = count;
  //       element.classList.remove('loading');
  //     });
  //   },
      _renderProductCount(html) {
      const productCountEl = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
      if (!productCountEl) return;

      const count = productCountEl.innerHTML;

      document.querySelectorAll('#ProductCount_header, #ProductCountDrawer, #facets-ProductCount').forEach((element) => {
        element.innerHTML = count;
        element.classList.remove('loading');
      });
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      const source = html.getElementById('ProductPerPage');
      if (container && source) container.innerHTML = source.innerHTML;
    },
    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('ProductFilter','CloseFilter');
    },
    _filterRemoveFocus() {
      const activeElement = document.getElementById('btn-filter');
      Alpine.store('xFocusElement').removeTrapFocus(activeElement);
    },
    setFilterHeaderHeight() {
      document.documentElement.style.setProperty('--height-sticky-filter',document.getElementById("FacetsWrapperDesktop").offsetHeight + "px");
    },
    setPositionOptionFilter(el) {
      elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    },
    getPopupPosition(el) {
      this.$nextTick(() => {
        const elPopup = el.getElementsByClassName('popup-above')[0];
        if (elPopup) {
          const popupRect = elPopup.getBoundingClientRect();
          if( popupRect.right > window.innerWidth){
            elPopup.style.right = 0;
          }
        }
      });
    }
  }));
});
